var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcessAuditsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4167 33.3333L21.7708 26.9792L25.9375 31.1458L33.3333 23.8021V27.0833H37.5V16.6667H27.0833V20.8333H30.3646L25.9375 25.2604L21.7708 21.0937L12.5 30.4167L15.4167 33.3333ZM6.25 43.75V6.25H43.75V43.75H6.25ZM10.4167 39.5833H39.5833V10.4167H10.4167V39.5833Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4167 33.3333L21.7708 26.9792L25.9375 31.1458L33.3333 23.8021V27.0833H37.5V16.6667H27.0833V20.8333H30.3646L25.9375 25.2604L21.7708 21.0937L12.5 30.4167L15.4167 33.3333ZM6.25 43.75V6.25H43.75V43.75H6.25ZM10.4167 39.5833H39.5833V10.4167H10.4167V39.5833Z",
    fill: "url(#pattern0)",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessAuditsIcon);
export default __webpack_public_path__ + "static/media/ProcessAudits-icon.7ce08a196a2593af04addf825081b6ab.svg";
export { ForwardRef as ReactComponent };